module.exports = __webpack_public_path__ + "fonts/mc-icons.woff";